module.exports = __webpack_public_path__ + "static/media/financial-worries@3x.a125b656.png";